export default "__VITE_ASSET__Dse66x3c__"